<template>
    <div :class="{'wrapped': wrapSelect}" class="select-input">
        <div
            ref="select"
            :class="{'no-pad-left': selected.length > 0}"
            class="select-input-inner"
            tabindex="0"
            @click="handleClick"
            @mousedown="handleMousedown"
            @focus="handleFocus"
            @blur="handleBlur"
            @keyup.enter.stop.prevent="handleEnter"
            @keyup.space.stop="handleEnter"
            @keyup.esc.stop="$emit('click', false)"
            @keyup.delete.stop="$emit('click', false)"
            @keyup.up.stop="handleUp"
            @keyup.down.stop="handleDown"
            @keydown.down.prevent=""
            @keydown.up.prevent=""
            @keydown.enter.prevent="">
            <span v-show="selected.length === 0">{{ placeholder }}</span>
            <span 
                v-for="(item, index) in selected"
                ref="select-tag"
                :key="item.value"
                :class="{'margin-bottom': isBottom(index)}"
                class="select-tag">
                <span class="text">{{ item.label }}</span>
                <span class="button"><i class="el-tag__close icon-close" @mousedown.stop="" @click.stop="handleRemoveClick(item)"/></span>
            </span>
        </div>
        <div
            :class="{'select-open': isOpen}"
            class="select-input-arrow"
            @mousedown.stop="handleArrowMousedown"
            @click="handleArrowClick">
            <i class="icon-dropdown"/>
        </div>
    </div>
</template>

<script>
import emitter from '@/utilities/emitter'
import { clearTimeout, setTimeout } from 'timers';

export default {
    name: 'app-select-input',
    mixins: [emitter],
    inject: {
        AppForm: {
            default: ''
        },
        AppFormItem: {
            default: ''
        },
        AppSelect: {
            default: ''
        }
    },
    props: {
        isOpen: Boolean,
        placeholder: {
            type: String,
            default: 'Select'
        },
        selected: Array
    },
    data() {
        return {
            focused: false,
            timeoutId: null,
            arrowMousedown: false,
            shouldEmitClick: true,
            wrapSelect: false
        }
    },
    computed: {
        value() {
            return this.AppSelect.value
        }
    },
    methods: {
        focus() {
            this.$refs.select.focus();
        },
        handleRemoveClick(item) {
            this.$emit('removeOption', {'label': item.label, 'value': item.value} )
        },
        handleClick() {
            let prevIsOpen = this.isOpen
            clearTimeout(this.timeoutId)
            if (this.shouldEmitClick) {
                this.timeoutId = setTimeout( ()=>{
                    if (prevIsOpen !== this.isOpen)
                        this.$emit('click', this.isOpen)
                    else
                        this.$emit('click', !this.isOpen)
                }, 100)
            }
            this.shouldEmitClick = true
        },
        handleArrowClick() {
            this.focus();
            this.arrowMousedown = false
            this.handleClick()
        },
        handleArrowMousedown() {
            this.arrowMousedown = true
        },
        handleMousedown() {
            if (this.$refs['select'] !== document.activeElement)
                this.shouldEmitClick = false
        },
        handleFocus(evt) {
            clearTimeout(this.timeoutId)
            this.timeoutId = setTimeout( ()=>{
                this.$emit('focus', evt)
            }, 100)
        },
        handleBlur(evt) {
            if(!this.arrowMousedown) {
                clearTimeout(this.timeoutId)
                this.timeoutId = setTimeout( ()=> {
                    this.$emit('blur', evt)
                }, 100)
            }
        },
        handleEnter() {
            this.$emit('enter')
        },
        handleUp() {
            this.$emit('up')
        },
        handleDown() {
            this.$emit('down')
        },
        checkLineWrap() {
            this.$nextTick( ()=> {
                if (this.$refs['select-tag'] && this.$refs['select-tag'].length > 0) {
                    if (this.$refs['select-tag'][0].offsetTop !== this.$refs['select-tag'][ this.$refs['select-tag'].length-1 ].offsetTop)
                        this.wrapSelect = true
                    else
                        this.wrapSelect = false
                }
                else
                    this.wrapSelect = false
            })
        },
        isBottom(index){
            if (this.$refs['select-tag'] && this.$refs['select-tag'].length > 0 && this.$refs['select-tag'][index] ){
                return this.$refs['select-tag'][0].offsetTop !== this.$refs['select-tag'][index].offsetTop
            }
        }
    },
    watch: {
        value: {
            handler() {
                this.checkLineWrap()
            },
            immediate: true
        }
    }
}
</script>

<style lang="stylus" scoped>

    .app-form-item
        &.is-success
            .select-input-inner
                border-color: #67c23a
        &.is-error
            .select-input-inner
                border-color: #f56c6c !important

    .no-pad-left
        padding-left: 0px !important
        padding-top: 0px !important

    .select-input
        width: 100%
        position: relative
        display: inline-block
        cursor: pointer
        &.wrapped
            line-height: 30px
         
    .select-input-inner
        border: 1px solid #d3d5d9
        border-radius: 6px
        padding: 1px 30px 0 15px
        color: #C0C4CC
        min-height: 44px
        font-size: 14px
        background: white
        &:focus
            border-color: #409EFF
            outline: none
            -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1)
            -o-transition: border-color .2s cubic-bezier(.645,.045,.355,1)
            transition: border-color .2s cubic-bezier(.645,.045,.355,1)

    .select-input-arrow
        color: #909399
        font-size: 14px
        display: inline
        position: absolute
        right: 16px
        top: 50%
        -ms-transform: translateY(-50%)
        transform: translateY(-50%)
        i
            display: inline-block
            transition: .2s
            margin-top: 4px
            margin-bottom: 0
    
    .select-open i
        transform: rotate(-180deg)
        margin-top: 0
        margin-bottom: 3px
    
    .select-tag
        -webkit-box-sizing: border-box
        cursor: text
        box-sizing: border-box
        border: none
        border-radius: 6px
        display: inline-block
        margin: 6px 0 2px 8px
        background-color: #f0f2f5
        height: 24px
        padding: 0 8px
        line-height: 22px
        white-space: nowrap
        &.margin-bottom
            margin-bottom: 7px
        .text
            color: #909399
            font-size: 12px
        .button
            display: inline-block
            i
                display: inline-block
                background-color: #C0C4CC
                cursor: pointer
                right: -4px
                top: 0
                color: #FFF
                border-radius: 50%
                text-align: center
                position: relative
                cursor: pointer
                font-size: 12px
                height: 16px
                width: 16px
                line-height: 16px
                vertical-align: middle
                -webkit-transform: scale(0.8)
                transform: scale(0.8)
                &:before
                    display: block
                    transform: translate(0,1.8px)
                &:hover
                    background-color: #909399

</style>

